const caseInsensitiveIndexOf = (string, substring) => string.toLowerCase().indexOf(substring.toLowerCase());

const caseInsensitiveCompare = (stringA, stringB) => {
    const a = stringA.toLowerCase();
    const b = stringB.toLowerCase();
    if (a.toLowerCase() > b.toLowerCase()) {
        return 1;
    }
    if (b.toLowerCase() > a.toLowerCase()) {
        return -1;
    }

    return 0;
}

const filter = (suggestions, query) => {
    // Matches from beginning of word boundaries only
    const match = new RegExp(`\\b${query}`, 'i');
    return suggestions.filter((suggestion) => {
        return suggestion.match(match);
    });
};

const groupByIndex = (suggestions, query) => {
    return suggestions.reduce((groupedSuggestions, currentResult) => {
        const currentResultIndex = caseInsensitiveIndexOf(currentResult, query);

        if (!groupedSuggestions[currentResultIndex]) {
            groupedSuggestions[currentResultIndex] = [];
        }

        groupedSuggestions[currentResultIndex].push(currentResult);
        groupedSuggestions[currentResultIndex].sort(caseInsensitiveCompare);

        return groupedSuggestions;
    }, {});
};

const flattenToArrayInKeyOrder = (suggestions) => {
        return Object.keys(suggestions).sort((a, b) => a - b).reduce((results, groupKey) => {
        const group = suggestions[groupKey];
        group.forEach((result) => {
            results.push(result);
        });
        return results;
    }, []);
};

class Suggestions {
    constructor(suggestions = []) {
        this.suggestions = suggestions;
    }

    filter(query) {
        this.suggestions = filter(this.suggestions, query);
        return this;
    }

    sort(query) {
        this.suggestions = flattenToArrayInKeyOrder(groupByIndex(this.suggestions, query));
        return this;
    }

    // @TODO if this class was an subclass of Array then this would be redundant
    toArray() {
        return this.suggestions;
    }
}

const generateSuggestions = (data, query) => {
    return new Suggestions(data)
        .filter(query)
        .sort(query)
        .toArray();
};

module.exports = {
    generateSuggestions,
    flattenToArrayInKeyOrder,
    caseInsensitiveIndexOf,
    caseInsensitiveCompare,
};


// WEBPACK FOOTER //
// ./js/suggestions.js